// Simple groupBy helper function.
// Usage:
// groupBy([
//   { text: 'foo', groupName: 'bar' },
//   { text: 'baz', groupName: 'bang' },
// ], 'groupName')
// => { bar: [ { text: 'foo', group: 'bar' } ],
//      bang: [ { text: 'baz', group: 'bang' } ] }
export const groupBy = (array: any[], key: string) =>
  array.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
